import { render, staticRenderFns } from "./rel-consultations-specialtys.vue?vue&type=template&id=7efd2cc0&scoped=true"
import script from "./rel-consultations-specialtys.vue?vue&type=script&lang=js"
export * from "./rel-consultations-specialtys.vue?vue&type=script&lang=js"
import style0 from "./rel-consultations-specialtys.vue?vue&type=style&index=0&id=7efd2cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd2cc0",
  null
  
)

export default component.exports